import { useDatabaseEntity } from './useDatabaseEntity';

export interface ProductDetails {
  id: string;
  name: string;
  description: string | undefined;
  draft: boolean;
  lifecycleStage: string | undefined;
  createdAt: string;
  remoteReference: { provider: string; url: string } | undefined;
}

export function useProduct(productId: string | undefined) {
  const { entity, loading, error } = useDatabaseEntity<ProductDetails>(productId, {
    entityType: 'Product',
    build: (database, id) => {
      // NOTE: products live under `projects()` in the WASM database — preserved
      // from the original hook. Likely a tsify-generated naming relic.
      const obj = database.projects()[id];
      if (!obj) return null;
      const ref = obj.remote_reference();
      return {
        id,
        name: obj.name(),
        description: obj.description() ?? undefined,
        draft: obj.draft(),
        lifecycleStage: obj.lifecycle_stage() ?? undefined,
        createdAt: obj.created_at(),
        remoteReference: ref ? { provider: ref.provider, url: ref.url } : undefined,
      };
    },
  });
  return { product: entity, loading, error };
}
